import { Dispatch, SetStateAction, useId, useState } from "react";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../../../firebase";
import AdminButton from "../../../core/admin/adminButton";
import AdminSpinner from "../../../core/admin/adminSpinner";
import { UploadIcon } from "../../../../img/svg/adminIcons";


export default function HeaderInput({ saveImgUrl, loading, setLoading, refresh }: { saveImgUrl: (url: string) => Promise<void>, loading: boolean, setLoading: Dispatch<SetStateAction<boolean>>, refresh: () => void }) {

    const inputId = useId();

    const [picText, setPicText] = useState("");
    const [picValue, setPicValue] = useState<File | null>(null);
    const [picSize, setPicSize] = useState(0);
    // const [prog, setProg] = useState(0);
    // const [cProg, setCProg] = useState(0);
    const [hasError, setHasError] = useState(false);

    const sendImage = async (e: any) => {
        e?.preventDefault?.();
        try {
            setLoading(true);
            setHasError(false);
            let imgUrl = "";
            if (!picValue) {
                setLoading(false);
                return null;
            }
            if (picSize > 5) {
                setLoading(false);
                return null;
            }
            const storageRef = ref(storage, `headerimages/${picText}`);
            const uploadTask = await uploadBytesResumable(storageRef, picValue);
            imgUrl = await getDownloadURL(uploadTask.ref);
            saveImgUrl(imgUrl);
            onCancel();
        } catch (error) {
            console.log(error);
            setLoading(false);
        }

    }

    const onChoose = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            const files = e.target.files;
            if (!files) {
                return null;
            }
            const file = files[0];
            setPicSize(file.size / 1024000);
            setPicValue(file);
            setPicText(file.name);
        } catch (error) {
            console.log(error);
        }
    }

    const onCancel = () => {
        setPicValue(null);
        setPicText("");
        setPicSize(0);
        setLoading(false);
        refresh();
    }

    return (
        <div>
            {
                loading ?
                    <div className="flex h-24 items-center justify-center rounded-xl border-2 border-dashed border-gray-300 text-gray-500">
                        <AdminSpinner />
                    </div>
                    : !picValue ?
                        <label title="Adicionar" htmlFor={inputId} className="flex h-24 cursor-pointer flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-gray-300 text-sm text-gray-500 transition hover:border-gray-900 hover:text-gray-900">
                            <UploadIcon />
                            <span className="font-semibold">Adicionar nova imagem</span>
                            <span className="text-xs text-gray-400">até 5MB</span>
                            <input id={inputId} type="file" accept="image/*" className="hidden" onChange={e => onChoose(e)} />
                        </label>
                        :
                        <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3">
                            <p className={`flex-1 min-w-0 text-sm break-all ${picSize > 5 ? "text-red-600 font-semibold" : "text-gray-800"}`}>
                                {picText} {picSize ? `(${picSize.toFixed(2)}MB)` : null}
                                {
                                    picSize > 5 ?
                                        <span className="block text-xs">Arquivo maior que 5MB.</span>
                                        : null
                                }
                            </p>
                            <div className="flex gap-2">
                                <AdminButton size="sm" variant="secondary" onClick={onCancel} className="flex-1">Cancelar</AdminButton>
                                <AdminButton size="sm" disabled={loading || !picValue || picSize > 5} onClick={() => sendImage(null)} className="flex-1">Enviar</AdminButton>
                            </div>
                        </div>
            }
            {
                hasError ?
                    <p className="mt-2 text-sm text-red-600">Erro no envio!</p>
                    : null
            }

        </div>
    )
}
